
<app-featuress 
bgImage="blog.jpg.jpeg"
minHeight="60vh"
bannerText=""
brandName=""
separator="">
</app-featuress>
<app-blogs></app-blogs>